"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _imageModule = _interopRequireDefault(require("./image.module.css"));
var ImageContainer = function ImageContainer(props) {
  var _classNames, _classNames2;
  var aspectRatioPercentage = props.aspectRatioPercentage,
    contentProp = props.content,
    sources = props.sources,
    expandToContent = props.expandToContent,
    hasAspectRatio = props.hasAspectRatio,
    loaded = props.loaded,
    lazy = props.lazy,
    overflow = props.overflow,
    offset = props.offset,
    children = props.children;

  // TODO: with the introduction of the new aspectRatio
  // prop in v2.7, consider renaming aspectRatioPercentage or
  // adding more documentation around its usage
  // during the react-image refactor (see https://nerdwallet.atlassian.net/browse/FEI-1158)
  var aspectRatioPercentageString = "".concat(aspectRatioPercentage, "%");
  var overrideAspectRatio = Boolean(sources.length > 1 || !aspectRatioPercentage);
  var content = contentProp && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_imageModule.default.children, (_classNames = {}, (0, _defineProperty2.default)(_classNames, (0, _classes.default)('position-absolute'), !expandToContent), (0, _defineProperty2.default)(_classNames, (0, _classes.default)('position-relative'), expandToContent), _classNames))
  }, contentProp);
  var reactLazyloadPlaceholder = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_imageModule.default['react-lazyload-placeholder'])
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_imageModule.default.container, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, _imageModule.default['aspect-ratio-content'], hasAspectRatio), (0, _defineProperty2.default)(_classNames2, (0, _classes.default)('position-relative'), !hasAspectRatio), _classNames2))
  }, !overrideAspectRatio && /*#__PURE__*/_react.default.createElement("div", {
    className: _imageModule.default.sizer,
    style: {
      paddingTop: aspectRatioPercentageString,
      // Using inline styles here due to conflict with reset CSS and widgets causing the margin to be set to 0.
      marginLeft: '-1px'
    }
  }), lazy ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_imageModule.default.lazyload, (0, _defineProperty2.default)({}, _imageModule.default['lazyload--loaded'], loaded))
  }, /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
    once: true,
    overflow: overflow,
    offset: offset,
    placeholder: reactLazyloadPlaceholder
  }, children)) : children, content);
};
ImageContainer.displayName = 'ImageContainer';
ImageContainer.propTypes = {
  aspectRatioPercentage: _propTypes.default.number,
  children: _propTypes.default.node,
  content: _propTypes.default.node,
  expandToContent: _propTypes.default.bool,
  hasAspectRatio: _propTypes.default.bool,
  lazy: _propTypes.default.bool,
  loaded: _propTypes.default.bool,
  offset: _propTypes.default.number,
  overflow: _propTypes.default.bool,
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  sources: _propTypes.default.array
};
var _default = ImageContainer;
exports.default = _default;